import colors from 'vuetify/es5/util/colors'

export default {
  light: {
    primary: colors.yellow,
    secondary: colors.green.darken3,
    accent: colors.deepPurple.darken3,
    success: colors.green.darken3,
    error: colors.deepOrange.darken4,
    'input-text-color': '#222',
    // Light text on dark background
    'light-text-color': '#ddd'
  }
// TODO: Define dark theme and auto switch or allow manual theme selection
}
